export const blockIconsContentSend = (
	<span className='material-symbols-outlined'>send</span>
);
